//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import commportallogin from "@/pcpage/hr/recruitment/portal/commportallogin";
export default {
  name: "retrievePWD",
  extends: commportallogin,
  data() {
    return {
      record: {},
      isSendCode: false,
      sendCodeText: "Send Code",
      sendCodeTime: "",
      statusImg: {
        true: require("../../../../assets/images/success.png"),
        false: require("../../../../assets/images/error1.png"),
      },
      ifpassworderror: false, //是否展示密码验证失败提示信息
      passwordpass: false, //验证密码是否验证成功
      passworderror: false, //验证密码是否验证失败
      passwordpass2: false, //验证密码是否验证成功
      passworderror2: false, //验证密码是否验证失败
      changeUrl: "api/api/portalLogin/updatePassword", //修改密码URL
    };
  },
  methods: {
     loginPage() {
      this.$router.push({
        path: "/portal/login",
        query: {},
      });
    },
    async updatePassword() {
      //修改密码URL
      let flag = await this.checkForm1();
      if (flag) {
        if (!this.passwordpass || !this.passwordpass2) {
          this.$msgDailog.showMsgBox({
            title: "New password doesn't match the validation rule.",
          });
          return false;
        }
        let params = {
          record: this.record,
        };
        this.axios
          .post(this.changeUrl, params)
          .then(({ data }) => {
            if (data.code == "1") {
              let msg = data.data.msg;
              if (this.isNotNullOrEmpty(msg)) {
                this.$msgDailog.showMsgBox({
                  title: msg,
                });
              } else {
                this.$router.push({
                  path: "/portal/successOperate",
                  query: { showtype: "update" },
                });
              }
            }
          })
          .catch((error) => console.log(error));
      }
    },
    /**sendCode() {
            if (!this.isSendCode) {
                this.isSendCode = true;
                this.sendCodeText = 60;
                this.sendCodeTime = setInterval(() => {
                    if (this.sendCodeText !== 1) {
                        this.sendCodeText -= 1;
                    } else {
                        clearInterval(this.sendCodeTime);
                        this.sendCodeText = "Send Code";
                    }
                }, 1000);
            }
        },**/
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/retrievePWD.vue